module.exports = __webpack_public_path__ + "img/it-3.4f9ab413.png";